import React from 'react';
import styles from './yandexLink.module.sass';
import { Icon } from '../Icon';
import { Anchor } from '../Text';
import { IconSVG } from '../SpriteSVG';

export const YandexLink = ({ link, isShip }) => (
  <div className={styles.badge}>
    <Anchor href={link} variant="yandexButton" className={styles.linkInside}>
      {' '}
      Ознакомиться со статьей {isShip ? 'о теплоходе ' : 'о круизе '}{' '}
      <div className={styles.yandexText}>
        Яндекс
        <Icon
          icon={<IconSVG name={'social/dzen'} width={41} height={40} />}
          leftGap={6}
          rightGap={3}
        />{' '}
        Дзен
      </div>
    </Anchor>
  </div>
);
